export const REGISTER_USER = "REGISTER_USER";
export const RESET_FORM = "RESET_FORM";
export const SET_LOGGED_USER = "SET_LOGGED_USER";
export const SET_LOGGED_SPREMIUM_USER = "SET_LOGGED_SPREMIUM_USER";
